module.exports = __webpack_public_path__ + "static/media/sf_hotel_5.1c32468d.jpg";